import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DecadenceGameData} from "../server/DecadenceData";
import {Decadence} from "../Decadence";

export class DecadencePromoPanelConfig implements PromoPanelGameConfiguration {

    constructor() {

    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "Munchies",
            hasActionSpin: true,
            mainGame: {
                header: ()=>"xBET",
                options: [
                    //{name:"NORMAL", id:0, image:"NORMAL.png"},
                    //{name:"REELS_2" ,id:1, image:"REELS_2.png"},
                    //{name:"REELS_4" ,id:2, image:"REELS_4.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {backgroundTextureName: "introBg"},
            getParsedData: (response: DecadenceGameData, bet: number, prevResponse: DecadenceGameData):ASWinData => {
                return {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: Decadence.model.triggeredFreeSpins,
                    totalSpinWinnings: Decadence.model.spinWinnings, //response.totalSpinWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response), //response.nextMode == GameMode.NORMAL,
                    isBonusEnd: response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL,
                    isWinCapHit: response.brokeTheBank,
                }
            }
        };
    }

    onActionSpinPlaySound(trigger: ActionSpinSound) {
        const sound = trigger == ActionSpinSound.BIG_WIN ? "bigwinEnds" : "reelLandingWin";
        Decadence.soundPlayer.playSound(sound);
    }

    private isBigWin(response:DecadenceGameData):boolean {
        if(Decadence.model.betPrice > (Decadence.model.data.playedBetValue * 15)) {
            return Decadence.model.spinWinnings >= Decadence.model.betPrice;
        } else {
            return Decadence.model.spinWinRatio >= 15;
        }
    }

    private getFeatureName(response:DecadenceGameData):string {
        const modeToCheck = Decadence.model.triggeredFreeSpins ? response.nextMode : response.mode;
        switch (modeToCheck) {
            case "FREESPIN":                return "IT'S ALIVE!!";
            case "FREESPIN_SUPER":          return "DEVOUR SPINS";
            default:                        return "NORMAL";
        }
    }

    private isRoundComplete(response:DecadenceGameData):boolean {
        return ([GameMode.FREESPIN,GameMode.FREESPIN_SUPER, GameMode.NORMAL].indexOf(response.nextMode) > -1);

    }
}